import { api } from "../../../services/api";

export async function updateMotoboy({ idOrcamento, cdMotoboy }) {
  await api.patch("/updateMotoboy", { idOrcamento, cdMotoboy });
  return;
}
